// extracted by mini-css-extract-plugin
export default {"imageContainer":"f2-z","summaryPar":"g2-z","ratingCategories":"h2-z","reviewerInfo":"i2-z","reviewTypes":"j2-z","expanded":"k2-z"};